<div
  *ngIf="visible"
  id="beta-banner"
  class="static w-full text-white bg-primary-purple-base"
  [@slideInOut]
  aria-label="Close welcome message"
  role="button"
  data-cy="beta-banner"
>
  <div class="flex flex-column align-items-center text-center py-3 px-5">
    <i
      class="mi-round mi-close absolute cursor-pointer beta-banner-close-icon"
      (click)="visibleChange.emit(false)"
      tabindex="0"
    ></i>
    <div class="beta-banner-text">
      <p class="p2 my-4 sm:my-3">
        Has your insurance changed recently? When authorizing your next reorder, please verify and update your insurance
        coverage if necessary.
      </p>
    </div>
  </div>
</div>
